import React from 'react';
import PropTypes from 'prop-types';

const SrCardContainer = ({ children, onCardClicked }) => (
  <div className="SrCardContainer" onClick={onCardClicked}>
    {children}
  </div>
);

SrCardContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onCardClicked: PropTypes.func,
};

SrCardContainer.displayName = 'SrCardContainer';

export default SrCardContainer;
